import type { SectionSmall3 } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: SectionSmall3['items'];
};

export function BoardSectionTileSmall3({ boardSectionItems }: Props) {
	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				{boardSectionItems.map((boardSectionItem, index) => {
					return (
						// eslint-disable-next-line @eslint-react/no-array-index-key
						<Tracktor key={`${boardSectionItem.rowId}_${index}`} trackingData={{ data: { inSectionPlacement: index } }}>
							<BoardSectionItem teaser={boardSectionItem} sizes={IMAGE_SIZE_ONE_THIRD} />
						</Tracktor>
					);
				})}
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
